// a redux slice to manage case
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CaseState {
  caseId: string | null;
  caseName?: string;
  caseNameFrench?: string;
  caseDescription?: string;
  caseDescriptionFrench?: string;
  caseStatus?: boolean;
  caseShortName?: string;
  timeZone?: number;
  abbreviation?: string;
  caseData?: any;
  caseUnits?: any;
  defaultUnit?: any;
}

export interface CasePermission {
  Creditor: string[];
  Debtor: string[];
  Unit: string[];
  ClaimItemCategory: string[];
  ClaimStageDefinition: string[];
  ClaimStatusDefinition: string[];
  RateTier: string[];
  RateTierTemplate: string[];
  Case: string[];
  User: string[];
  UserCaseGroup: string[];
  AttributeDefinition: string[];
  AttributeValue: string[];
  Scheme: string[];
  SchemeVersion: string[];
  Class: string[];
  Rule: string[];
  ClaimStageInstance: string[];
  ClaimStatusInstance: string[];
  Claim: string[];
  ClaimItem: string[];
  ClaimHistorySnapshot: string[];
  ClaimItemHistorySnapshot: string[];
  Account: string[];
  CalculationStep: string[];
  CalculationSettings: string[];
  Distribution: string[];
  StepClassFilter: string[];
  StepDataSource: string[];
  StepLimitAmount: string[];
  PayeeType: string[];
  Ballot: string[];
  Settlement: string[];
  Entitlement: string[];
  SubAccount: string[];
  ImportJob: string[];
  Document: string[];
  ClaimTask: string[];
  Meeting: string[];
  CreditorVote: string[];
  ManualDataSource: string[];
  Payment: string[];
  ReportResults: string[];
  BallotUnlock: string[],
  ChequeUpdate: string[],
  OriginalAmountUpdate: string[]
  checkingPermissions?: boolean;
  hasCasePermission?: boolean;
  validCaseId?: boolean;
}

const initialState: CasePermission = {
  Creditor: ["Read", "Test"],
  Debtor: ["Read"],
  Unit: ["Read"],
  ClaimItemCategory: ["Read"],
  ClaimStageDefinition: ["Read"],
  ClaimStatusDefinition: ["Read"],
  RateTier: ["Read"],
  RateTierTemplate: ["Read"],
  Case: ["Read"],
  User: ["Read"],
  UserCaseGroup: ["Read"],
  AttributeDefinition: ["Read"],
  AttributeValue: ["Read"],
  Scheme: ["Read"],
  SchemeVersion: ["Read"],
  Class: ["Read"],
  Rule: ["Read"],
  ClaimStageInstance: ["Read"],
  ClaimStatusInstance: ["Read"],
  Claim: ["Read"],
  ClaimItem: ["Read"],
  ClaimHistorySnapshot: ["Read"],
  ClaimItemHistorySnapshot: ["Read"],
  Account: ["Read"],
  CalculationStep: ["Read"],
  CalculationSettings: ["Read"],
  Distribution: ["Read"],
  StepClassFilter: ["Read"],
  StepDataSource: ["Read"],
  StepLimitAmount: ["Read"],
  PayeeType: ["Read"],
  Ballot: ["Read"],
  Settlement: ["Read"],
  Entitlement: ["Read"],
  SubAccount: ["Read"],
  ImportJob: ["Read"],
  Document: ["Read"],
  ClaimTask: ["Read"],
  Meeting: ["Read"],
  CreditorVote: ["Read"],
  ManualDataSource: ["Read"],
  Payment: ["Read"],
  ReportResults: ["Read"],
  BallotUnlock: [""],
  ChequeUpdate: ["" ],
  OriginalAmountUpdate: ["" ],
  hasCasePermission: false,
  validCaseId:true,
  checkingPermissions:true
};

export const casePermissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setCasePermission: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload };
    },
    setCaseCheckingPermission: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload };
    },
    resetCasePermission: () => {
      return initialState;
    },
  },
});

export const { setCasePermission, setCaseCheckingPermission, resetCasePermission } = casePermissionSlice.actions;

export default casePermissionSlice.reducer;
